import { CompanyCard } from "@components/CompanyCard/CompanyCard";
import { useCompanies } from "@hooks/useCompany";
import React from "react";
import styles from "./ActiveCompaniesList.module.scss";
import { THEME_COLOR } from "@utils/Constants";
import ReactLoading from "react-loading";
import { useTranslations } from "next-intl";

const SKELETON_COUNT = 12;

export default function ActiveCompaniesList({
    sort,
    filter,
    search,
    onTotalCountChange,
    onClearSearch,
}) {
    const { data, isValidating, setSize } = useCompanies({
        sort,
        filter,
        limit: 12,
        search,
    });
    let companies = data?.map((page) => page.results).flat();
    const apiTotalCount = data?.[0]?.count || 0;
    const t = useTranslations("CustomersPage");

    React.useEffect(() => {
        if (apiTotalCount > 0 && onTotalCountChange) {
            onTotalCountChange(apiTotalCount);
        }
    }, [apiTotalCount, onTotalCountChange]);

    const handleFetchMore = () => {
        setSize((size) => size + 1);
    };

    if (!companies) {
        return (
            <div className={styles.grid}>
                {Array.from({ length: SKELETON_COUNT }).map((_, i) => (
                    <CompanyCard key={i} company={null} index={i} />
                ))}
            </div>
        );
    }

    if (companies.length === 0) {
        return (
            <div className={styles.emptyState}>
                <p className={styles.emptyText}>{t("not_fond_companies")}</p>
                <button className={styles.clearBtn} onClick={onClearSearch}>
                    {t("clear_search")}
                </button>
            </div>
        );
    }

    const showCount = apiTotalCount > 0;

    return (
        <div className={styles.container}>
            <div className={styles.grid}>
                {companies.map((company, i) => (
                    <CompanyCard key={company.id} company={company} index={i} />
                ))}
            </div>
            <div className={styles.loadMoreWrap}>
                {showCount && (
                    <span className={styles.countLabel}>
                        {t("showing_of", {
                            loaded: companies.length,
                            total: apiTotalCount,
                        })}
                    </span>
                )}
                <button
                    className={styles.loadMoreBtn}
                    disabled={isValidating}
                    onClick={handleFetchMore}
                >
                    {t("view_more")}
                </button>
                {isValidating && (
                    <ReactLoading
                        type="bubbles"
                        color={THEME_COLOR}
                        width="60px"
                        height="60px"
                    />
                )}
            </div>
        </div>
    );
}
